export const brazeWhitelistAttributes = [
  // Core user identity
  'Email',
  'Hash Email',
  'Is New Email',
  'InitialUserID',
  'Initial User ID',
  'Unified UID',
  'Phone Number',
  'Full Name',

  // User location & language
  'User Country Code',
  'User Country',
  'User Country Source',
  'User IP Address',
  'User Language',
  'Language',
  'Country',
  'Country Code',

  // User preferences & behavior
  'User Initial Product',
  'Who is it for',
  'Chosen Gift',
  'Art User',
  'AR Quick Look Support',

  // Consent & marketing
  'Web Email Marketing Consent Given',
  'sms_screen_last_seen',
  'Phone Number Captured',
  'Phone Number Consent Given',

  // Timestamps
  'last_order_timestamp',

  // Cart & user flow data
  'User Cart - PHOTO_BOOKS Flow - Cover Photo',
  'User Cart - PHOTO_BOOKS Flow - cartId',
  'User Cart - PHOTO_BOOKS Flow - Cover Caption',
  'Cover Photo Url',

  'Cart Abandon Preview URL',
  'User Cart - TILE_DESIGNER Flow - tilePreviews',
  'User Cart - TILE_DESIGNER Flow - cartId',
  'User Cart - TILE_DESIGNER Flow - Has Tiles',
  'User Cart - TILE_DESIGNER Flow - Has AI Templates Tiles',
  'User Cart - CART Flow - cartId',
  'User Cart - CART Flow - Product Types',
  'User Cart - CART Flow - Item Count',
  'User Cart - CART Flow - Item Titles',

  // Special Braze array attributes
  'Passed Who Is It For Step',
  'Web Email Captured',
  'Photo Picked',

  // AI generation attributes
  'AI Results',
  'AI Preview Results',
  'AI Preview Result',

  // Order completion event attributes
  'Order Completed',
  'Gift Card Order Completed',
]
